import { autoinject } from 'aurelia-framework';
import { ApiService } from '../../utils/api-service';

@autoinject
export class FiscalYearService {
	constructor(private api: ApiService) {
	}

	getFiscalYearsForCustomer(customerId: string): Promise<IFiscalYearAM[]> {
		return this.api.fetchJson(`customers/${customerId}/fiscal-years`);
	}

	getFiscalYear(fiscalYearId: string): Promise<IFiscalYearAM> {
		return this.api.fetchJson(`fiscalyears/${fiscalYearId}`);
	}
}

export class IFiscalYearAM {

	id: string;
	startDate: Date;
	endDate: Date;
	period: string;
	primaryServiceStructureId: string;
	organizationId: string;
}
